import React from "react"
import {ToFullSampleTypeName} from "../../utils/helpers";

export default class ReportDropdown extends React.Component{
	static defaultProps = {
		dairyId: -1,
		currentReportType: 'solo',
		reports: [],
		changeReportType: () => (console.log('Add a props function to ReportDropdown to update report type change'))
	}
	
	constructor(props){
		super(props)
		
		this.state = {
			selectedReport: props.currentReportType
		}
	}
	
	selectNewReport(event){
		const newReport = event.target.value
		
		this.setState({
			selectedReport: newReport
		}, () => {
			this.props.changeReportType(newReport)
		})
	}
	
	render(){
		const reportsForCurrentDairy = this.props.reports.filter(report => this.props.dairyId === report.report_dairy_id)
		
		const reportOptions = reportsForCurrentDairy.map((report) => (
			<option key={report.report_id} value={report.report_type}>{ToFullSampleTypeName(report.report_type)}</option>
		))
		
		return(
			<div>
				<p>Change Report:</p>
				<select value={this.state.currentReportType} onChange={this.selectNewReport.bind(this)}>
					{reportOptions}
				</select>
			</div>
		)
	}
}